import { APP_CONFIG } from "../constants/global-variables.js";

export async function getagents(startDate, endDate, currency) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/userhierarchy`;

  try {
    const res = await axios.post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        currency
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function getagentsByUser(startDate, endDate, currency) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/getagents`;

  try {
    const res = await axios.post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        currency
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function gettotalagents(startDate, endDate, currency, userId, role) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/gettotalagents`;

  try {
    const res = await axios.post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        currency,
        user_id: userId,
        role
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function getagentsByChildrenUser(startDate, endDate, agentId, currency) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/getagents`;

  try {
    const res = await axios.post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        children_id: agentId,
        currency
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function getBetsByUser(agentId, startDate, endDate, currency) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/mybets`;

  try {
    const res = await axios.post(
      url,
      {
        start_date: startDate,
        end_date: endDate,
        agent_id: agentId,
        currency
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents", err);
  }
}


export async function getBetsByUserFilter(agentId, startDate, endDate, currency, filterId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/mybetsstate`;

  try {
    const res = await axios.post(
      url,
      {
          start_date: startDate,
          end_date: endDate,
          agent_id: agentId,
          currency,
          bet_status: filterId
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.log("Error getting documents", err);
  }
}
